exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\r\n\r\n.separator_separator_1jjpt {\r\n  width: 100%;\r\n  border: none;\r\n  border-top: 2px solid var(--ui-black-transparent);\r\n  margin: 0.5rem 0;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"separator": "separator_separator_1jjpt"
};